import React from 'react';
import { Link } from 'react-router-dom';
import Logo from './Logo';
import { navLinks, site } from '../data/site';

// Adapted from Watermelon UI block "footer-1" (bordered panel, brand column + link groups).
const groups = [
  { title: 'Company', links: navLinks.map((l) => ({ label: l.label, to: l.href })) },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', to: '/privacy' },
      { label: 'Terms of Use', to: '/terms' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-paper-2 px-5 pb-8 sm:px-8 lg:px-12">
      <div className="mx-auto max-w-7xl rounded-xl border border-line bg-paper p-8 sm:p-12">
        <div className="flex flex-col justify-between gap-12 lg:flex-row lg:gap-24">
          <div className="max-w-sm space-y-6">
            <Logo />
            <p className="text-sm leading-relaxed text-ink-soft">
              Empowering businesses, elevating success. Bespoke digital marketing from Limassol, Cyprus.
            </p>
            <address className="space-y-1 text-sm not-italic text-ink-soft">
              <span className="block font-medium text-ink">{site.company}</span>
              {site.addressLines.map((line) => (
                <span key={line} className="block">{line}</span>
              ))}
              <a href={`mailto:${site.email}`} className="block pt-2 text-ink underline decoration-sage/50 underline-offset-4 hover:decoration-ink">
                {site.email}
              </a>
            </address>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:gap-20">
            {groups.map((group) => (
              <div key={group.title} className="space-y-5">
                <h4 className="text-sm font-medium text-ink">{group.title}</h4>
                <ul className="space-y-3.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link to={link.to} className="text-sm text-muted transition-colors hover:text-ink">
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-line pt-8 text-xs text-muted sm:flex-row">
          <p>&copy; {new Date().getFullYear()} {site.company}. All rights reserved.</p>
          <p>{site.address}</p>
        </div>
      </div>
    </footer>
  );
}
